import { useState, useEffect } from 'react';
import { SPLASH_CONFIG } from '../config/splashConfig';
import { SplashScreenManager } from '../utils/splashUtils';

export const useSplashScreen = () => {
  const [showSplash, setShowSplash] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const shouldShow = SplashScreenManager.shouldShowSplash();
    setShowSplash(shouldShow);

    if (!shouldShow) {
      setIsReady(true);
      setDataLoaded(true);
      return;
    }

    const minTimePromise = new Promise(resolve => 
      setTimeout(resolve, SPLASH_CONFIG.minDisplayTime)
    );

    const dataLoadPromise = new Promise(resolve => 
      setTimeout(resolve, 1000)
    );

    Promise.all([minTimePromise, dataLoadPromise]).then(() => {
      setDataLoaded(true);
    });
  }, []);

  const handleSplashComplete = () => {
    if (dataLoaded) {
      SplashScreenManager.markSplashShown();
      setShowSplash(false);
      setIsReady(true);
    }
  };

  useEffect(() => {
    if (dataLoaded && showSplash) {
      const timer = setTimeout(handleSplashComplete, 100);
      return () => clearTimeout(timer);
    }
  }, [dataLoaded, showSplash]);

  return {
    showSplash,
    isReady,
    dataLoaded,
    handleSplashComplete
  };
};